import {Component, inject, OnInit} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {WidgetTemplate} from '../../widgets/models/widget-template';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatCheckboxModule} from '@angular/material/checkbox';

@Component({
  standalone: true,
  selector: 'via-widget-selection-modal',
  imports: [MatButtonModule, MatCheckboxModule, MatDialogModule],
  templateUrl: './widget-selection.modal.html',
  styleUrls: ['./widget-selection.modal.scss'],
})
export class WidgetSelectionModal implements OnInit {
  private readonly dialogRef = inject(MatDialogRef);
  private readonly dialogData = inject(MAT_DIALOG_DATA);

  private _availableWidgets: WidgetTemplate[] = [];

  ngOnInit() {
    this._availableWidgets = this.dialogData['availableWidgets'].sort((a: WidgetTemplate, b: WidgetTemplate) =>
      (a.title ?? '').localeCompare(b.title ?? '', undefined, {
        sensitivity: 'base',
      }),
    );
  }

  get availableWidgets(): WidgetTemplate[] {
    return this._availableWidgets;
  }

  toggleWidgetEnabled(widgetTemplate: WidgetTemplate) {
    widgetTemplate.enabled = !widgetTemplate.enabled;
  }

  saveTemplateSelection() {
    this.dialogRef.close('SAVE');
  }

}
